import { gsap } from 'gsap';

class Service extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();

    this.scrollIn = false;

    this.others = [...document.querySelectorAll('service-module')].filter(n => n !== this);

    this.addEventListener('click', this.openCloseSection.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.openCloseSection.bind(this));
  }

  init() {
    this.prepareAnimation();

    let $this = this;
    this.videos = this.querySelectorAll('video');
    this.images = this.querySelectorAll('img');

    if (this.videos) {
      this.videos.forEach(video => {

        video.addEventListener( "loadedmetadata", function() {

          video.pause();
          const height = this.videoHeight;
          const width = this.videoWidth;

          if(video.parentNode.classList.contains('ratio-box')) {
            video.parentNode.style.setProperty('--pad', ((height / width) * 100) + '%');
          }

          video.height = height;
          video.width = width;

        }, {capture: false, once: true, passive: true});
      });
    }
  }

  // animationComplete() {}
  calculateHeight() {
    return this.firstElementChild.clientHeight;
  }
    
  prepareAnimation(scroll = false) {
    let $this = this;

    this.opener = gsap.timeline({
      paused: true,
      duration: .25,
      ease: "power3.InOut",
    }).reverse();

    this.opener.to(this.firstElementChild, {
      opacity: 1,
    }, 0)

    this.opener.to(this, {
      height: () => { return this.firstElementChild.clientHeight },
      backgroundColor: '#fff',
      color: '#666',
      onComplete: function() {
        $this.playPauseVideos(true);
        $this.ariaHidden = "false";

        if($this.scrollIn) {
          window.scrollTo({
            top: $this.offsetTop,
            behavior: "smooth"
          });
        }
      },
      onReverseComplete: function() {
        $this.playPauseVideos(false);
        $this.ariaHidden = "true";
      }
    }, 0);
  }

  openCloseSection(e, scroll = false) {
    this.scrollIn = scroll;

    if (this.ariaHidden === "true") {
      this.opener.reversed(false);
    } else if(this.ariaHidden === "false") {
      this.opener.reversed(true);
    }

    this.others.forEach(el => {
      el.opener.reversed(true);
    });
  }

  playPauseVideos(state) {
    this.videos.forEach(video => {
      if(state) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

}
customElements.define('service-module', Service);